import { useEffect } from 'react';

export const useScrollToTopOnChange = (value: unknown) => {
  useEffect(() => {
    const animationFrame = window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0 });
    });

    return () => window.cancelAnimationFrame(animationFrame);
  }, [value]);
};
